var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBelle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2397_3700)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.6635C23.375 11.6635 26.1306 14.3258 26.2466 17.7044L26.2501 17.9135V21.3277L27.4001 23.9577C27.4576 24.0893 27.4873 24.2314 27.4873 24.375C27.4873 24.9503 27.0209 25.4167 26.4456 25.4167L22.5001 25.4179C22.5001 26.7986 21.3808 27.9179 20.0001 27.9179C18.6687 27.9179 17.5803 26.8771 17.5043 25.5648L17.4997 25.416L13.5624 25.4167C13.4197 25.4167 13.2784 25.3873 13.1474 25.3304C12.6198 25.1012 12.3778 24.4877 12.607 23.96L13.7501 21.3284V17.9134C13.7505 14.4511 16.5435 11.6635 20.0001 11.6635ZM21.2497 25.416L18.7501 25.4179C18.7501 26.1083 19.3097 26.6679 20.0001 26.6679C20.6498 26.6679 21.1838 26.1722 21.2443 25.5383L21.2497 25.416ZM20.0001 12.9135C17.2333 12.9135 15.0005 15.1421 15.0001 17.9135V21.5882L13.8801 24.1667H26.1272L25.0001 21.589L25.0001 17.9242L24.997 17.7366C24.9045 15.042 22.7014 12.9135 20.0001 12.9135Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2397_3700",
    x: -16.6667,
    y: -16.6667,
    width: 73.3333,
    height: 73.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2397_3700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2397_3700",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelle);
export default __webpack_public_path__ + "static/media/belle.beb2483f4f128c47d65021ca83b06a20.svg";
export { ForwardRef as ReactComponent };